import * as React from 'react';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Slide from '@material-ui/core/Slide';
import styled from 'styled-components';
import Modal, { ModalProps } from 'components/@client/Modal';
import { MOBILE_RESOLUTION } from 'styles/sharedStyle';
import PaymentForm from 'components/@client/PaymentForm/PaymentForm';
import { useSession } from 'hooks';
import { SelectedProductCoin } from 'types/products';
import { CheckOutPersonalDetailPayload } from 'types/orders';
import StripeForm from 'components/@client/StripePayment/StripeForm';
// import { SupportedCountry } from 'types/common.types';
import { useIntl } from 'react-intl';

interface Props extends ModalProps {
  personalDetail?: CheckOutPersonalDetailPayload | null;
  coins?: SelectedProductCoin | null;
  deliveryDate?: Date;
  hs?: string;
  publicKey: string;
  clientSecretKey: string;
}

const PaymentModal: React.FC<Props> = ({
  personalDetail,
  coins,
  deliveryDate,
  hs,
  publicKey,
  clientSecretKey,
  ...props
}) => {
  const { country } = useSession();
  const intl = useIntl();
  const checkCountry = intl.locale === 'he' || country === 'IL';
  const isMobile = useMediaQuery(MOBILE_RESOLUTION);
  return (
    <Container
      fullWidth
      fullScreen={isMobile}
      TransitionComponent={Slide}
      transitionDuration={400}
      title=""
      {...props}
      actions={[]}
      conditionalMargin={checkCountry}
    >
      {country ? (
        <PaymentForm
          deliveryDate={deliveryDate}
          personalDetail={personalDetail}
          coins={coins}
          hs={hs}
        />
      ) : (
        <StripeForm
          deliveryDate={deliveryDate}
          personalDetail={personalDetail}
          coins={coins}
          hs={hs}
          publicKey={publicKey}
          clientSecretKey={clientSecretKey}
        />
      )}
    </Container>
  );
};

export default PaymentModal;

const Container = styled(Modal)<{ conditionalMargin: boolean }>`
  .MuiDialogContent-root {
    width: fit-content;
    @media (min-width: 1150px) {
      overflow-y: hidden;
    }

    @media (max-width: 500px) {
      padding: 0;
    }
  }
  &&.client-dialog .MuiDialog-paper {
    border-radius: 12px;
    width: fit-content;
  }

  &&.client-dialog .MuiDialog-paper .MuiDialogTitle-root {
    font-size: 1.25rem;
    h2 {
      font-weight: 700;
    }
  }

  & .MuiDialogContent-root {
    padding: 0;
    /* margin: ${({ conditionalMargin }) =>
      conditionalMargin ? '0px' : '40px'}; */
    margin: 0;
    color: rgba(21, 25, 32, 0.5);

    @media (max-width: 500px) {
      padding: 0;
    }
  }
`;
